module.exports = __webpack_public_path__ + "img/level1_idle_gun.0d759783.png";